/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class Roles {
  static readonly admin: string = 'Admin';
  static readonly evaluator: string = 'Evaluator';
  static readonly thirdParty: string = 'Third_Party';
  static readonly candidate: string = 'Candidate';
}
